import { btnIcons } from '../assets/btnIcons';
import { getTextAreaFontSize } from '../textChat/helpers/getTextAreaFontSize';
import { isMobile } from '../helpers/helpers';
import { uiState } from '../state';
import { fixTextChatSizeIfNeeded, getTextChatSizeAfterResize } from '../textChat/resize';
import { generateKeyFrame, getStyleSheetMarker, mergeOptionsForStyleSheet } from './common';
import { getInnerBorderRadiusProp, getNumPropVal, getPaddingProp, parseSvgSize, svgToBase64 } from './cssHelper';


const flexMap = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
};

export function generateCssForChat(webOptions) {

    let keyFrames = '';
    const textChatOptions = uiState.textChat.options;

    const defaultMinChatHeight = 400;
    const defaultChatHeight = 700;
    const chatHeaderHeight = +textChatOptions?.header?.height || 40;
    const chatTextareaLineHieght = uiState.textChat.defaults.textareaLineHeight;
    const textareaHolderHeight = +textChatOptions?.footer?.height || 67;
    const chatMicBtnActiveSize = 32;
    const textChatScrollSize = 6;
    const defaultChatTextareaFontSize = uiState.textChat.defaults.textareaFontSize;
    const withSendBtnOutside = textChatOptions?.footer?.layout?.name === 'send-btn-outside';

    const footerTopPadding = getNumPropVal(textChatOptions?.footer?.padding?.top, 2);
    const footerRightPadding = getNumPropVal(textChatOptions?.footer?.padding?.right, 18);
    const footerBottomPadding = getNumPropVal(textChatOptions?.footer?.padding?.bottom, 15);
    const footerLeftPadding = getNumPropVal(textChatOptions?.footer?.padding?.left, 18);

    const headerTopPadding = getNumPropVal(textChatOptions?.header?.padding?.top, 12);
    const headerRightPadding = getNumPropVal(+textChatOptions?.header?.padding?.right, 11);
    const headerBottomPadding = getNumPropVal(textChatOptions?.header?.padding?.bottom, 0);
    const headerLeftPadding = getNumPropVal(textChatOptions?.header?.padding?.left, 11);


    const msgsTopPadding = getNumPropVal(textChatOptions?.popup?.padding?.top, 20);
    const msgsRightPadding = getNumPropVal(textChatOptions?.popup?.padding?.right, 15);
    const msgsBottomPadding = getNumPropVal(textChatOptions?.popup?.padding?.bottom, 20);
    const msgsLeftPadding = getNumPropVal(textChatOptions?.popup?.padding?.left, 15);

    const buttonsTopPadding = getNumPropVal(textChatOptions?.buttons?.padding?.top, 9)
    const buttonsRightPadding = getNumPropVal(textChatOptions?.buttons?.padding?.right, 20)
    const buttonsBottomPadding = getNumPropVal(textChatOptions?.buttons?.padding?.bottom, 9)
    const buttonsLeftPadding = getNumPropVal(textChatOptions?.buttons?.padding?.left, 20)

    const requestBubbleTopPadding = getNumPropVal(textChatOptions?.bubbles?.request?.padding?.top, 9);
    const requestBubbleRightPadding = getNumPropVal(textChatOptions?.bubbles?.request?.padding?.right, 20);
    const requestBubbleBottomPadding = getNumPropVal(textChatOptions?.bubbles?.request?.padding?.bottom, 9);
    const requestBubbleLeftPadding = getNumPropVal(textChatOptions?.bubbles?.request?.padding?.left, 20);

    const responseBubbleTopPadding = getNumPropVal(textChatOptions?.bubbles?.response?.padding?.top, 9);
    const responseBubbleRightPadding = getNumPropVal(textChatOptions?.bubbles?.response?.padding?.right, 20);
    const responseBubbleBottomPadding = getNumPropVal(textChatOptions?.bubbles?.response?.padding?.bottom, 9);
    const responseBubbleLeftPadding = getNumPropVal(textChatOptions?.bubbles?.response?.padding?.left, 20);

    const newDialogSeparatorColor = textChatOptions?.bubbles?.newDialog?.separator?.color || `#d3dae2`;
   
    const waitingResponseBubbleLayout = textChatOptions?.bubbles?.waitingResponse?.layout || 'default';

    const responseBubbleBorderRadiusTopLeft = getNumPropVal(textChatOptions?.bubbles?.response?.borderRadius?.topLeft, defaultBubbleBorderRadius);
    const responseBubbleBorderRadiusTopRight = getNumPropVal(textChatOptions?.bubbles?.response?.borderRadius?.topRight, defaultBubbleBorderRadius);
    const responseBubbleBorderRadiusBottomRight = getNumPropVal(textChatOptions?.bubbles?.response?.borderRadius?.bottomRight, defaultBubbleBorderRadius);
    const responseBubbleBorderRadiusBottomLeft = getNumPropVal(textChatOptions?.bubbles?.response?.borderRadius?.bottomLeft, defaultBubbleBorderRadius);

    const btnsGap = getNumPropVal(textChatOptions?.buttons?.gap, 8);

    const textareaTopPadding = getNumPropVal(textChatOptions?.textarea?.padding?.top, 12);
    const textareaRightPadding = getNumPropVal(textChatOptions?.textarea?.padding?.right, 42);
    const textareaBottomPadding = getNumPropVal(textChatOptions?.textarea?.padding?.bottom, 12);
    const textareaLeftPadding = getNumPropVal(textChatOptions?.textarea?.padding?.left, 12);

    const requestBubbleLabelTopPadding = getNumPropVal(textChatOptions?.bubbles?.request?.label?.padding?.top, 0);
    const requestBubbleLabelRightPadding = getNumPropVal(textChatOptions?.bubbles?.request?.label?.padding?.right, 0);
    const requestBubbleLabelBottomPadding = getNumPropVal(textChatOptions?.bubbles?.request?.label?.padding?.bottom, 4);
    const requestBubbleLabelLeftPadding = getNumPropVal(textChatOptions?.bubbles?.request?.label?.padding?.left, 0);
    const requestBubbleLabelFontSize = getNumPropVal(textChatOptions?.bubbles?.request?.label?.fontSize, 15);
    const requestBubbleLabelColor = textChatOptions?.bubbles?.request?.label?.color || `#171717`;
    const requestBubbleLabelEnabled = uiState?.textChat?.options?.bubbles?.request?.label?.enabled === true;

    const responseBubbleLabelTopPadding = getNumPropVal(textChatOptions?.bubbles?.response?.label?.padding?.top, 0);
    const responseBubbleLabelRightPadding = getNumPropVal(textChatOptions?.bubbles?.response?.label?.padding?.right, 0);
    const responseBubbleLabelBottomPadding = getNumPropVal(textChatOptions?.bubbles?.response?.label?.padding?.bottom, 4);
    const responseBubbleLabelLeftPadding = getNumPropVal(textChatOptions?.bubbles?.response?.label?.padding?.left, 0);
    const responseBubbleLabelFontSize = getNumPropVal(textChatOptions?.bubbles?.response?.label?.fontSize, 15);
    const responseBubbleLabelColor = textChatOptions?.bubbles?.response?.label?.color || `#171717`;
    const responseBubbleLabelEnabled = uiState?.textChat?.options?.bubbles?.response?.label?.enabled === true;

    const btnAlignment = textChatOptions?.buttons?.alignment?.default || 'center';
    const btnAlignmentFullscreen = textChatOptions?.buttons?.alignment?.fullScreen || 'center';

    const textChatAppearAnimationMs = uiState.textChat.defaults.appearAnimationMs;

    const headerLayoutName = textChatOptions?.header?.layout?.name || 'centered-title';


    let cssChatHeight = getTextChatSizeAfterResize('height');
    let cssChatWidth = getTextChatSizeAfterResize('width');

    fixTextChatSizeIfNeeded(cssChatWidth, cssChatHeight);

    cssChatHeight = getTextChatSizeAfterResize('height');
    cssChatWidth = getTextChatSizeAfterResize('width');

    if (cssChatHeight) {
        cssChatHeight = `${cssChatHeight}px`;
    } else {
        cssChatHeight = `${migrateHeightFromPercent(textChatOptions?.popup?.height) || defaultChatHeight}px`;
    }

    function migrateHeightFromPercent(val) {
        if (val && +val <= 100) {
            return defaultChatHeight;
        }
        return val;
    }


    if (cssChatWidth) {
        cssChatWidth = `${cssChatWidth}px`;
    } else {
        cssChatWidth = `${textChatOptions?.popup?.width || `400`}px`;
    }

    const chatBgColor1 = textChatOptions?.popup?.backgroundColor || `#DAEBFF`;
    const chatBgColor2 = textChatOptions?.popup?.backgroundColor2 || `#ffffff`;
    const chatGradientType = textChatOptions?.popup?.gradientType || `linear`;
    const chatCustomBg = textChatOptions?.popup?.background?.customCss;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder {
        position: fixed;
        height:  ${cssChatHeight};
        min-height: ${textChatOptions?.popup?.minHeight || defaultMinChatHeight}px;
        max-height: ${textChatOptions?.popup?.maxHeight || `1200`}px;
        width: ${cssChatWidth};
        min-width: ${textChatOptions?.popup?.minWidth || uiState.textChat.defaults.minChatWidth}px;
        max-width: ${textChatOptions?.popup?.maxWidth || `1200`}px;
        display: none;
        transform: scale(0);
        opacity: 0;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.alan-btn_text-chat-full-screen {
        position: fixed;
        height:  100%!important;
        min-height: 100%!important;
        max-height: 100%!important;
        width: 100%!important;
        min-width: 100%!important;
        max-width: 100%!important;
        top:0!important;
        bottom:0!important;
        left:0!important;
        right:0!important;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.alan-btn__inlined-chat:not(.alan-btn_text-chat-full-screen) {
        position: static;
        height:  100%!important;
        max-height: 100%!important;
        width: 100%!important;
        max-width: 100%!important;
        top:0!important;
        bottom:0!important;
        left:0!important;
        right:0!important;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__inlined-chat .alan-btn__chat {
        border-radius:0!important;
        box-shadow: none;
    }`;

    const sideBarAnimaDuration = 200;
    const sideBarWidth = 280;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-side-bar {
        min-height: 100%;
        max-height: 100%;
        height: 100%;
        background-color: ${chatBgColor1};
        box-shadow: inset 1px 0px 13px 0px rgba(16, 39, 126, 0.2);
        display:none;
        transition: width ${sideBarAnimaDuration}ms ease-in-out, max-width ${sideBarAnimaDuration}ms ease-in-out, min-width ${sideBarAnimaDuration}ms ease-in-out;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-side-bar {
        display: flex;
        width: 0px;
        min-width: 0px;
        max-width: 0px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen.alan-btn__side-bar-expanded  .alan-btn__chat-side-bar {
        width: ${sideBarWidth}px;
        min-width: ${sideBarWidth}px;
        max-width: ${sideBarWidth}px;
        transition: width ${sideBarAnimaDuration}ms ease-in-out, max-width ${sideBarAnimaDuration}ms ease-in-out, min-width ${sideBarAnimaDuration}ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat {
        border-radius:0!important;
        flex-direction: row;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-messages {
        max-width: 870px;
        width: 100%;
        margin: 0 auto;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-textarea-holder {
        min-width: initial;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-textarea-holder-outer-content {
        max-width: 860px;
        margin: 0 auto;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-textarea-inner-holder {
        width: 100%;
        height: 100%;
        position:relative;
        display:flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-clear-btn {
        left: 3px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-enter-full-screen-mode  {
        display: block;
        min-width: 20px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-exit-full-screen-mode  {
        display: none;
        min-width: 20px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-enter-full-screen-mode  {
        display: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-exit-full-screen-mode  {
        display: block;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__openning {
        transform: scale(0);
        opacity: 0;
        animation: text-chat-appear-anim ${textChatAppearAnimationMs}ms ease-in-out forwards;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('text-chat-appear-anim',
        `
    0%{
        transform: scale(0);
        opacity: 0;
    }
    100%{
        transform: scale(1);
        opacity: 1;
    }
    `);

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__closing {
        transform: scale(1);
        opacity: 1;
        animation: text-chat-disappear-anim ${textChatAppearAnimationMs}ms ease-in-out forwards;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('text-chat-disappear-anim',
        `
    0%{
        transform: scale(1);
        opacity: 1;
    }
    100%{
        transform: scale(0);
        opacity: 0;
    }
    `);

    keyFrames += '.mobile' + getStyleSheetMarker() + `.alan-btn__chat-holder {
        position: fixed; 
        height: 100%;
        min-height: 100%;
        max-height: 100%;
        width: 100vw;
        min-width: 100vw;
        max-width: 100vw;
        display: none;
        top: 0;
        bottom:0;
        left:0;
        right:0;
        border-radius: 0px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.bottom-none {
        cursor: ns-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.top-none {
        cursor: ns-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.none-left {
        cursor: ew-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.none-right {
        cursor: ew-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.top-left {
        cursor: nwse-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.bottom-right {
        cursor: nwse-resize;
      }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.top-right {
        cursor: nesw-resize;
      }`;
    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.bottom-left {
        cursor: nesw-resize;
      }`;

    const defaulPopupBorderRadius = 20;
    keyFrames += getStyleSheetMarker() + `.alan-btn__chat {
        height: 100%;
        position: relative;
        overflow: hidden;
        display: flex;
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        flex: 2;
        position: relative;
        flex-direction: column;
        box-shadow: 0px 5px 44px rgba(0, 0, 0, 0.15);
        ${textChatOptions?.popup?.hasBorder === true ? `border: 1px solid ${textChatOptions?.popup?.borderColor || '#ffffff'};` : ''}
        border-radius: ${textChatOptions?.popup?.borderRadius?.topLeft || defaulPopupBorderRadius}px ${textChatOptions?.popup?.borderRadius?.topRight || defaulPopupBorderRadius}px ${textChatOptions?.popup?.borderRadius?.bottomRight || defaulPopupBorderRadius}px ${textChatOptions?.popup?.borderRadius?.bottomLeft || defaulPopupBorderRadius}px;
    }`;

    const headerBg = textChatOptions?.header?.backgroundColor || `#FFFFFF`;
    let chatBackgroud = `linear-gradient(180deg, ${headerBg} 0px, ${headerBg} 30px, ${chatBgColor2} 0%, ${chatBgColor2} 15%, ${chatBgColor1} 70%, ${chatBgColor1} 100%)`;

    if (chatGradientType === 'radial') {
        chatBackgroud = `radial-gradient(circle, ${chatBgColor2} 0%, ${chatBgColor1} 100%)`;
    }

    if (chatGradientType === 'custom' && chatCustomBg) {
        chatBackgroud = chatCustomBg;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__popup-chat, ${getStyleSheetMarker() + `.alan-btn__history-chat`} {
        height: 100%;
        position: relative;
        overflow: hidden;
        display: flex;
        flex: 2;
        position: relative;
        flex-direction: column;
        animation: chat-appear 300ms ease-in-out forwards;
        transform: scale(1);
        opacity: 1; 
        background: ${chatBackgroud};
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('alan-btn__sound-bar-1', `
    0% {
        opacity: 0; 
        transform: scale(0);
    }
    100% {
        opacity: 1;  
        transform: scale(1);   
    }`);

    keyFrames += '.mobile' + getStyleSheetMarker() + `.alan-btn__chat {
        border-radius: 0px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea-holder {
        width: 100%;
        min-height: ${textareaHolderHeight}px;
        background-color: ${textChatOptions?.footer?.backgroundColor || '#DAEBFF'};
        position: relative;
        display: flex;
        flex-shrink: 0;
        padding: ${getPaddingProp(footerTopPadding, footerRightPadding, footerBottomPadding, footerLeftPadding)};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea-holder-outer-content {
        width: 100%;
        height: 100%;
        display: flex;
        gap: 8px;
        position: relative;
    }`;
    const defaultTextareaBorderRadius = 20;
    const topRightBorderRadius = textChatOptions?.textarea?.borderRadius?.topRight || defaultTextareaBorderRadius;
    const bottomRightBorderRadius = textChatOptions?.textarea?.borderRadius?.bottomRight || defaultTextareaBorderRadius;
    const calculatedTextareaRightPadding = Math.max(Math.max(topRightBorderRadius, bottomRightBorderRadius), textareaRightPadding);

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea-inner-holder {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        overflow: hidden;
        border-radius: ${textChatOptions?.textarea?.borderRadius?.topLeft || defaultTextareaBorderRadius}px ${topRightBorderRadius}px ${bottomRightBorderRadius}px ${textChatOptions?.textarea?.borderRadius?.bottomLeft || defaultTextareaBorderRadius}px;
        border: 1px solid ${textChatOptions?.textarea?.borderColor || textChatOptions?.textarea?.backgroundColor || `transparent`};
        box-shadow: ${textChatOptions?.textarea?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        background-color: ${textChatOptions?.textarea?.backgroundColor || `#ffffff`} ;
        padding: ${getPaddingProp(0, calculatedTextareaRightPadding, 0, 0)};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-empty-block {
        flex: 1 1 auto;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        padding: ${getPaddingProp(msgsTopPadding, msgsRightPadding, msgsBottomPadding, msgsLeftPadding)};
        display: flex;
        flex-shrink: 1;
        flex-direction: column-reverse;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header {
        width: 100%;
        height: ${chatHeaderHeight}px;
        max-height: ${chatHeaderHeight}px;
        min-height: ${chatHeaderHeight}px;
        color: #0f2029;
        padding: ${getPaddingProp(headerTopPadding, headerRightPadding, headerBottomPadding, headerLeftPadding)};
        background: ${headerBg};
        color: ${textChatOptions?.header?.color || `#000000`};
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        position:relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: ${headerLayoutName === 'centered-title' ? 'center' : 'flex-start'};
        position:relative;
    }`;

    const headerFontSize = textChatOptions?.header?.fontSize || 16;
    const headerIconGap = getNumPropVal(textChatOptions?.header?.icon?.gap, 12);
    const headerAlignment = textChatOptions?.header?.alignment || 'center';

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-title {
        max-width: calc(100% - 112px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: ${headerAlignment};
        font-weight: 600;
        font-size: ${headerFontSize}px;
        gap: ${headerIconGap}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-title-icon {
        display: flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-title-label {
        display: flex;
    }`;

    const withGradientForHeader = uiState.textChat.options?.header?.withBottomGradient !== false;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-gradient {
        width: 100%;
        height: 15px;
        max-height: 15px;
        min-height: 15px;
        position: absolute;
        left:0;
        display: ${withGradientForHeader ? 'block' : 'none'};
        width: 100%;
        top: ${chatHeaderHeight}px;
        background: linear-gradient(180deg, ${headerBg} 30%, rgba(255, 255, 255, 0) 100%);
    }`;

    keyFrames += getStyleSheetMarker() + `.with-hover .alan-btn__chat-header::after {
        opacity: 0.8;
        transition: 300ms opacity ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.with-cursors .alan-btn__chat-messages {
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
    }`;

    if (isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn {
            display: none;
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn svg path {
        stroke: ${textChatOptions?.popup?.icons?.mute?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn:hover svg path {
            stroke: ${textChatOptions?.popup?.icons?.mute?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn.disabled {
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-unmute-btn.disabled {
        opacity: 0.4
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn {
        display: ${textChatOptions?.popup?.icons?.clear?.visible === false ? 'none' : 'flex'};
        align-items: center;
        height: 100%;
        cursor: pointer;
        position: relative;
    }`;

    keyFrames += getStyleSheetMarker() + `.multi-line .alan-btn__chat-clear-btn {
        align-items: flex-end;
        padding-bottom: ${textareaBottomPadding}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn.disabled {
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn.disabled {
        opacity: 0.4
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn path.alan-chat__dialog-icon  {
        stroke: ${textChatOptions?.popup?.icons?.clear?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn:hover path.alan-chat__dialog-icon {
            stroke: ${textChatOptions?.popup?.icons?.clear?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn path.alan-chat__plus-icon {
        fill: ${textChatOptions?.popup?.icons?.clear?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-clear-btn:hover path.alan-chat__plus-icon {
            fill: ${textChatOptions?.popup?.icons?.clear?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-left-icons {
        position: absolute;
        top:0;
        left:0;
        height: 100%;
        display: flex;
        align-items: center;
        gap: 4px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-header-right-icons {
        position: absolute;
        top:0;
        right:0;
        height: 100%;
        display: flex;
        align-items: center;
        gap: 4px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar-header {
        display: flex;
        flex-direction: row;
        padding: 0 10px;
        width: 100%;
        justify-content: space-between;
        white-space:nowrap;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__toogle-side-bar-btn {
        margin-right: 6px;
        height: ${chatHeaderHeight}px;
        display: flex;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__toogle-side-bar-btn svg path {
        fill: ${textChatOptions?.popup?.icons?.sideBar?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__toogle-side-bar-btn:hover svg path {
            fill: ${textChatOptions?.popup?.icons?.sideBar?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__close-chat-btn {
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__close-chat-btn svg path {
        fill: ${textChatOptions?.popup?.icons?.close?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__close-chat-btn:hover svg path {
            fill: ${textChatOptions?.popup?.icons?.close?.hover?.fill || `#97989c`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-bar__new-chat-btn {
        margin-right: 6px;
        height: ${chatHeaderHeight}px;
        display: flex;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
        color: #000;
        padding: 2px 8px;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__side-panel-chat-btn {
        margin-right: 6px;
        height: ${chatHeaderHeight}px;
        display: flex;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
        display:none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__side-panel-chat-btn {
        display:flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen.alan-btn__side-bar-expanded .alan-btn__side-panel-chat-btn {
        display:none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-panel-chat-btn svg {
        min-width: 22px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__side-panel-chat-btn svg path {
        fill: ${textChatOptions?.popup?.icons?.sideBar?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__side-panel-chat-btn:hover svg path {
            fill: ${textChatOptions?.popup?.icons?.sideBar?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__close-chat-btn {
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen.alan-btn__side-bar-expanded .alan-btn__close-chat-btn {
        display: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__close-chat-btn svg path {
        fill: ${textChatOptions?.popup?.icons?.close?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__close-chat-btn:hover svg path {
            fill: ${textChatOptions?.popup?.icons?.close?.hover?.fill || `#97989c`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__minimize-chat-btn {
        height: 100%;
        display: ${textChatOptions?.popup?.minimizeMode?.enabled ? 'flex' : `none`};
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__minimize-chat-btn svg path {
        stroke: ${textChatOptions?.popup?.icons?.minimize?.default?.fill || `#969EB0`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__minimize-chat-btn:hover svg path {
            stroke: ${textChatOptions?.popup?.icons?.minimize?.hover?.fill || `#0046ff`};
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__save-chat-state-btn {
        height: 100%;
        display: ${textChatOptions?.popup?.saveChatState?.enabled ? 'flex' : `none`};
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__save-chat-state-btn-disabled {
        opacity: 0.5;
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__save-chat-state-btn  svg path {
        stroke: ${textChatOptions?.popup?.icons?.saveChatState?.default?.fill || `#969EB0`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__save-chat-state-btn:hover svg path {
        stroke: ${textChatOptions?.popup?.icons?.saveChatState?.hover?.fill || `#0046ff`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__save-chat-state-btn.saving {
        opacity: 0.4;
        pointer-events:none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__expand-collapse-chat-btn {
        height: 100%;
        display: ${textChatOptions?.popup?.fullScreenMode?.enabled ? 'flex' : `none`};
        align-items: center;
        cursor: pointer;
        pointer-events: all;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__expand-collapse-chat-btn  svg path {
        fill: ${textChatOptions?.popup?.icons?.fullScreen?.default?.fill || `#969EB0`};
        stroke: transparent;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__expand-collapse-chat-btn:hover svg path {
        fill: ${textChatOptions?.popup?.icons?.fullScreen?.hover?.fill || `#0046ff`};
        stroke: transparent;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__expand-collapse-chat-btn  svg rect  {
        stroke: ${textChatOptions?.popup?.icons?.fullScreen?.default?.fill || `#969EB0`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__expand-collapse-chat-btn:hover svg rect  {
        stroke: ${textChatOptions?.popup?.icons?.fullScreen?.hover?.fill || `#0046ff`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper {
        scrollbar-width: thin;
        scrollbar-color: rgba(224, 224, 224, 0.795) transparent;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table {
        scrollbar-width: thin;
        scrollbar-color: rgba(224, 224, 224, 0.795) transparent;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper::-webkit-scrollbar {
        width: ${textChatScrollSize}px;
        height: ${textChatScrollSize}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: rgba(224, 224, 224, 0.795);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper::-webkit-scrollbar-thumb:hover {
        background-color: rgba(230, 230, 230, 0.856);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table::-webkit-scrollbar-track {
        background: transparent;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table::-webkit-scrollbar {
        width: ${textChatScrollSize}px;
        height: ${textChatScrollSize}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: rgba(224, 224, 224, 0.795);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table::-webkit-scrollbar-thumb:hover {
        background-color: rgba(230, 230, 230, 0.856);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-messages-wrapper .scroll-table::-webkit-scrollbar-track {
        background: transparent;
    }`;

    const withGradientForFooter = textChatOptions?.footer?.withTopGradient !== false;
    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea-holder-gradient {
        background: linear-gradient(0deg, ${textChatOptions?.footer?.backgroundColor || textChatOptions?.popup?.backgroundColor || `#DAEBFF`} 30%, rgba(255, 255, 255, 0) 100%);
        height:15px;
        min-height:15px;
        width: 100%;
        position: absolute;
        top: -15px;
        display: ${withGradientForFooter ? 'block' : 'none'};
        left:0;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea {
        width: 100%;
        color: ${textChatOptions?.textarea?.color || `#171717`} ;
        overflow: hidden;
        outline: none;
        resize: none;
        background: transparent;
        border: none;
        -webkit-appearance: none;
        font-size: ${getTextAreaFontSize(isMobile(), textChatOptions?.textarea?.fontSize || defaultChatTextareaFontSize)}px;
        line-height: ${chatTextareaLineHieght};
        text-align: left;
        padding: ${getPaddingProp(textareaTopPadding, 0, textareaBottomPadding, textareaLeftPadding)};
        margin: 0px!important;
        -webkit-user-select: text;
        -khtml-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea::placeholder {
        color: ${textChatOptions?.textarea?.placeholderColor || `#747474`} ;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: rgba(224, 224, 224, 0.795);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea::-webkit-scrollbar-thumb:hover {
        background-color: rgba(230, 230, 230, 0.856);
        transition: background-color 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-textarea::-webkit-scrollbar-track {
        border-radius: 3px;
        background: transparent;
    }`;

    const micHolderWidth = 44;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-holder.alan-text-chat__voice-enabled .alan-btn__chat-textarea {
        padding-left: ${micHolderWidth}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__mic-active .alan-btn__chat-textarea {
        opacity: 0.6;
        transition: opacity 300ms ease-in-out;
        pointer-events: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__mic-active .alan-btn__chat-send-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__inactive .alan-btn__chat-send-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-textarea {
        opacity: 0.6;
        transition: opacity 300ms ease-in-out;
        pointer-events: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-send-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-unmute-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-clear-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-send-btn svg path {
        opacity: 1;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat .alan-btn__stop-response-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat .alan-btn__stop-response-btn svg {
        max-width: 22px;
        max-height: 22px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat.alan-btn__disconnected .alan-btn__chat-mic-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__inactive .alan-btn__chat-mic-btn {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_disconnected-chat-icon-rotate {
        animation: disconnected-chat-icon-rotate-animation 1500ms linear infinite;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('disconnected-chat-icon-rotate-animation', '0%{  transform: rotate(0deg);  } 100%{  transform: rotate(360deg);  }');

    keyFrames += getStyleSheetMarker() + `.alan-btn__disabled {
        opacity: 0.2;
        pointer-events: none;
        transition: opacity 300ms ease-in-out;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-send-btn {
        ${!withSendBtnOutside && `
        position: absolute;
        top: 0;
        right: 0px;
        width: 44px;
            `}
        height: 100%;
        transition: opacity 300ms ease-in-out;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE/Edge */
        user-select: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.multi-line .alan-btn__chat-send-btn {
        align-items: flex-end;
        padding-bottom: ${textareaBottomPadding}px;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-send-btn svg path {
        stroke: ${textChatOptions?.textarea?.placeholderColor || `#747474`};
        opacity: 0.5;
    }`;

    keyFrames += getStyleSheetMarker() + `.ready-to-send:not(.alan-btn__inactive) .alan-btn__chat-send-btn svg path {
        stroke: ${textChatOptions?.popup?.icons?.general?.default?.fill || `#171717`};
        opacity: 1;
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.ready-to-send:not(.alan-btn__inactive) .alan-btn__chat-send-btn:hover {
            cursor: pointer;
        }`;

        keyFrames += getStyleSheetMarker() + `.ready-to-send:not(.alan-btn__inactive) .alan-btn__chat-send-btn:hover svg path {
            stroke: ${textChatOptions?.popup?.icons?.general?.hover?.fill || `#0078ff`};
            opacity:0.8;
        }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn {
        position: absolute;
        left: 0px;
        top:0;
        height: 100%;
        width: ${micHolderWidth}px;
        transform-origin: center;
        display: flex;
        flex-direction: row;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }`;

    keyFrames += getStyleSheetMarker() + `.multi-line .alan-btn__chat-mic-btn {
        align-items: flex-end;
        transform-origin: bottom;
        padding-bottom: ${textareaBottomPadding}px;
    }`;

    const micActiveBottomPadding = +textareaBottomPadding - 2 >= 0 ?
        +textareaBottomPadding - 2 : 0;

    keyFrames += getStyleSheetMarker() + `.multi-line .alan-btn__chat-mic-btn.active {
        align-items: flex-end;
        padding-bottom: ${micActiveBottomPadding}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-notifications-bubble {
        position: absolute;
        right: 4px;
        top: -4px;
        height: 20px;
        width: 20px;
        background-color:  ${textChatOptions?.notifications?.backgroundColor || `#D0021B`};
        color:  ${textChatOptions?.notifications?.color || `#ffffff`};
        border-radius: 50%;
        z-index: ${uiState.btn.zIndex + 1};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 10px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-notifications-bubble:empty {
        display: none;
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn.active:hover::before {
        opacity: 0.35;
    }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn svg path {
        stroke: ${textChatOptions?.popup?.icons?.general?.default?.fill || `#171717`};
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn:hover svg path {
            stroke: ${textChatOptions?.popup?.icons?.general?.hover?.fill || `#007AFF`};
    }`;
    }

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__animated-btn-bars {
        height:${chatMicBtnActiveSize}px;
        width:${chatMicBtnActiveSize}px;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        background: ${textChatOptions?.popup?.icons?.general?.hover?.fill || `#007AFF`};
        display:none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn.active .alan-text-chat__animated-btn-bars  {
        display: flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-mic-btn.active svg  {
        display: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar {
        background: #ffffff;
        bottom: 1px;
        height: 3px;
        width: 2px;
        margin: 0px 1px;
        border-radius: 5px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar-1 {
        animation: alan-btn__sound-bar-1 0ms -1200ms linear infinite alternate;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar-2 {
        animation: alan-btn__sound-bar-2 0ms -1200ms linear infinite alternate;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar-3 {
        animation: alan-btn__sound-bar-3 0ms -1200ms linear infinite alternate;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('alan-btn__sound-bar-1', `
    0% {

        height: 3px; 
    }
    100% {
          
        height: 10px;        
    }`);

    keyFrames += getStyleSheetMarker() + generateKeyFrame('alan-btn__sound-bar-2', `
    0% {

        height: 8px; 
    }
    100% {
          
        height: 15px;        
    }`);

    keyFrames += getStyleSheetMarker() + generateKeyFrame('alan-btn__sound-bar-3', `
    0% {

        height: 12px; 
    }
    100% {
          
        height: 28px;        
    }`);

    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(1)  { animation-duration: 474ms; }`;
    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(2)  { animation-duration: 433ms; }`;
    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(3)  { animation-duration: 407ms; }`;
    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(4)  { animation-duration: 458ms; }`;
    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(5)  { animation-duration: 400ms; }`;
    keyFrames += getStyleSheetMarker() + `.alan-text-chat__bar:nth-child(6)  { animation-duration: 427ms; }`;



    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-bubble-holder {
        display: flex;
        flex-direction: row;
    }`;

    var defaultBubbleBorderRadius = 20;
    var requestBubbleBg = textChatOptions?.bubbles?.request?.backgroundColor || `#b2d6ff`;
    var responseBubbleBg = textChatOptions?.bubbles?.response?.backgroundColor || `#ffffff`;

    const avatarSize = 41;
    const avatarRightMargin = 10;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-request-label {
        text-align:right;
        display: ${requestBubbleLabelEnabled ? 'block' : 'none'};
        color: ${requestBubbleLabelColor};
        font-size: ${requestBubbleLabelFontSize}px;
        padding: ${getPaddingProp(requestBubbleLabelTopPadding, requestBubbleLabelRightPadding, requestBubbleLabelBottomPadding, requestBubbleLabelLeftPadding)};
        word-break: break-word;
        text-align: right;
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-request-label {
        text-align: left;
        padding-left: ${avatarSize + avatarRightMargin}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-request {
        margin-bottom: 16px;
        max-width: 90%;
        padding: ${getPaddingProp(requestBubbleTopPadding, requestBubbleRightPadding, requestBubbleBottomPadding, requestBubbleLeftPadding)};
        line-height: 1.53;
        display: block;
        float: right;
        clear: both;
        border-radius: ${textChatOptions?.bubbles?.request?.borderRadius?.topLeft || defaultBubbleBorderRadius}px ${textChatOptions?.bubbles?.request?.borderRadius?.topRight || defaultBubbleBorderRadius}px ${textChatOptions?.bubbles?.request?.borderRadius?.bottomRight || defaultBubbleBorderRadius}px ${textChatOptions?.bubbles?.request?.borderRadius?.bottomLeft || defaultBubbleBorderRadius}px;
        position: relative;
        border: 1px solid ${textChatOptions?.bubbles?.request?.borderColor || requestBubbleBg};
        box-shadow: ${textChatOptions?.bubbles?.request?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        background-color: ${requestBubbleBg};
        color: ${textChatOptions?.bubbles?.request?.color || `#171717`};
        font-size: ${textChatOptions?.bubbles?.request?.fontSize || `15`}px;
        word-break: break-word;
        text-align: left;
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-request {
        margin-bottom: 16px;
        max-width: 100%;
        float: initial;
        clear: initial;
        border-radius: 4px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-request * {
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    const responseBubbleFontSize = +(textChatOptions?.bubbles?.response?.fontSize || 15);
    const responseBubbleFontColor = textChatOptions?.bubbles?.response?.color || `#171717`;
    const responseBubbleLabelIconGap = getNumPropVal(textChatOptions?.bubbles?.response?.label?.icon?.gap, 12);
    const responseBubbleLabelAlignment = textChatOptions?.bubbles?.response?.label?.alignment || 'center';
    const responseLabelIcon = textChatOptions?.bubbles?.response?.label?.icon?.svg;
    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-label {
        display: ${responseBubbleLabelEnabled ? 'flex' : 'none'};
        align-items:${responseBubbleLabelAlignment};
        gap: ${responseBubbleLabelIconGap}px;
        position: relative;
        color: ${responseBubbleLabelColor};
        font-size: ${responseBubbleLabelFontSize}px;
        padding: ${getPaddingProp(responseBubbleLabelTopPadding, responseBubbleLabelRightPadding, responseBubbleLabelBottomPadding, responseBubbleLabelLeftPadding)};
        word-break: break-word;
        text-align: left;
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    const [responseLabelWidth, responseLabelHeight] = parseSvgSize(responseLabelIcon);

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-label-icon {
        display: ${responseLabelIcon ? 'flex' : 'none'};
        background-image: url('data:image/svg+xml;base64,${svgToBase64(responseLabelIcon)}');
        background-size: cover;
        ${responseLabelIcon ? `
        width: ${responseLabelWidth}px;
        height: ${responseLabelHeight}px;
        `: ''}
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-label-text {
        display: flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-response-label {
        text-align: left;
        padding-left: ${avatarSize + avatarRightMargin}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response {
        margin-bottom: 16px;
        max-width: 90%;
        padding: ${getPaddingProp(responseBubbleTopPadding, responseBubbleRightPadding, responseBubbleBottomPadding, responseBubbleLeftPadding)};
        line-height: 1.53;
        display: block;
        float: left;
        clear: both;
        border-radius: ${responseBubbleBorderRadiusTopLeft}px ${responseBubbleBorderRadiusTopRight}px ${responseBubbleBorderRadiusBottomRight}px ${responseBubbleBorderRadiusBottomLeft}px;
        position: relative;
        background-color: ${responseBubbleBg};
        border: 1px solid ${textChatOptions?.bubbles?.response?.borderColor || responseBubbleBg};
        box-shadow: ${textChatOptions?.bubbles?.response?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        color: ${responseBubbleFontColor};
        font-size: ${responseBubbleFontSize}px;
        word-break: break-word;
        text-align: left;
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.alan-incoming-msg {
        ${waitingResponseBubbleLayout === 'loader-and-label-wo-bubble' ?
            `padding: ${getPaddingProp(responseBubbleTopPadding, 0, responseBubbleBottomPadding, 0)};
            background: none;
            box-shadow: none;
            border-color:transparent;`:
            ``
        }
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-connection-separator {
        width: 100%;
        height: 1px;
        min-height: 1px;
        max-height: 1px;
        background-color: ${newDialogSeparatorColor};
        margin: 50px 0;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-buttons {
        margin-bottom: 16px;
        display:flex;
        flex-wrap: wrap;
        gap: ${btnsGap}px;
        justify-content: ${flexMap[btnAlignment]};
    }`;



    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-buttons {
          justify-content: ${flexMap[btnAlignmentFullscreen]};
          padding-left: ${avatarSize + avatarRightMargin}px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-buttons .alan-chat__chat-btn {
        text-align: ${textChatOptions?.buttons?.textAlign?.default || 'center'};
    }`;


    const defaultButtonBorderRadius = 20;
    keyFrames += getStyleSheetMarker() + `.alan-chat__chat-btn {
        margin-bottom: 8px;
        padding: ${getPaddingProp(buttonsTopPadding, buttonsRightPadding, buttonsBottomPadding, buttonsLeftPadding)};
        line-height: 1.53;
        display: inline-block;
        border-radius: ${textChatOptions?.buttons?.borderRadius?.topLeft || defaultButtonBorderRadius}px ${textChatOptions?.buttons?.borderRadius?.topRight || defaultButtonBorderRadius}px ${textChatOptions?.buttons?.borderRadius?.bottomRight || defaultButtonBorderRadius}px ${textChatOptions?.buttons?.borderRadius?.bottomLeft || defaultButtonBorderRadius}px;
        position: relative;
        background-color: ${textChatOptions?.buttons?.default?.backgroundColor || `#ffffff`};
        border: 1px solid ${textChatOptions?.buttons?.default?.borderColor || `#ffffff`};
        box-shadow: ${textChatOptions?.buttons?.default?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        color: ${textChatOptions?.buttons?.default?.color || `#171717`};
        font-size: ${textChatOptions?.buttons?.fontSize || `15`}px;
        word-break: break-word;
        text-align: left;
        cursor: pointer;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-chat__chat-btn:hover {
        background-color: ${textChatOptions?.buttons?.hover?.backgroundColor || `#ffffff`};
        border: 1px solid ${textChatOptions?.buttons?.hover?.borderColor || `#ffffff`};
        box-shadow: ${textChatOptions?.buttons?.hover?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        color: ${textChatOptions?.buttons?.hover?.color || `#0078ff`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-chat__chat-btn:active {
        background-color: ${textChatOptions?.buttons?.active?.backgroundColor || `#bcdafd`};
        border: 1px solid ${textChatOptions?.buttons?.active?.borderColor || `#bcdafd`};
        box-shadow: ${textChatOptions?.buttons?.active?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        color: ${textChatOptions?.buttons?.active?.color || `#0078ff`};
    }`;

    var chatResponseCssDeltaWidth = 82;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-response {
        margin-bottom: 16px;
        max-width: calc(100% - ${chatResponseCssDeltaWidth}px);
        min-width: calc(100% - ${chatResponseCssDeltaWidth}px)!important;
        float: initial;
        clear: initial;
        border-radius: 4px;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.with-images {
        min-width: 90%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-chat-small .alan-btn__chat-request {
        max-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-chat-small .alan-btn__chat-response {
        max-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-chat-small .alan-btn__chat-response.with-images {
        min-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.with-table {
        max-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.with-iframe {
        max-width: 100%;
        // width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.with-svg {
        max-width: 100%;
        width: 100%;
        min-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.with-svg iframe {
        max-width: 100%;
        width: 100%;
        min-width: 100%;
    }`;


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-request.animated {
        opacity:0;
        animation: chat-bubble-appear-w-opacity 300ms ease-in-out forwards;
        animation-delay: 100ms;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response.animated {
        opacity:0;
        animation: chat-bubble-appear-w-opacity 300ms ease-in-out forwards;
        animation-delay: 200ms;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('chat-bubble-appear-w-opacity', `
    0% { opacity:0;}
      
    100% {
        opacity:1;
    }`);


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response * {
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        top: -${responseBubbleTopPadding}px;
        left: -${responseBubbleLeftPadding}px;
        width: calc(100% + ${+responseBubbleRightPadding + (+responseBubbleLeftPadding)}px);
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-left-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 12px;
        opacity:0.85;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-right-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        opacity:0.85;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-left-arrow:hover {
        opacity:1;
        cursor: pointer;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-right-arrow:hover {
        opacity:1;
        cursor: pointer;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-left-arrow.invisible {
        opacity:0;
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper-right-arrow.invisible {
        opacity:0;
        pointer-events: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-img-block {
        overflow: hidden;
        border-radius: ${responseBubbleBorderRadiusTopLeft}px ${responseBubbleBorderRadiusTopRight}px 0 0;
        width: 100%;
        display: flex;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-video {
        width: 100%;
        min-width: 100%;
        min-height: 220px;
        height: 220px;
        max-height: 220px;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-img {
        cursor: pointer;
        transition: transform 300ms ease-in-out;
        width: 100%;
        min-width: 100%;
        min-height: 220px;
        height: 220px;
        max-height: 220px;
        object-fit: contain;
        pointer-events: initial;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-img.img-none {
        object-fit: none;
    }`;

    if (!isMobile()) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-imgs-wrapper:hover .alan-btn__chat-response-img {
            transform: scale(1.04);
            transition: transform 300ms ease-in-out;
        }`;
    }

    keyFrames += `.alan-btn__image-preview-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        min-height: 100vh;
        width: 100vw;
        min-width: 100vw;
        background-color: rgba(0,0,0,0.6);
        display: flex;
        align-items: center;
        justify-content: center;
    }`;


    keyFrames += `.alan-btn__image-preview-overlay img {
        max-width: calc(100% - 100px);
        max-height: calc(100% - 100px);
    }`;

    keyFrames += `@media only screen and (orientation: landscape) { 
        .alan-btn__image-preview-overlay.mobile {
            align-items: flex-start;
            padding-top: 40px;
        }
        .alan-btn__image-preview-overlay img {
            max-height: calc(100% - 120px);
        }
        .alan-btn__image-preview-overlay iframe {
            max-height: calc(100% - 120px);
        }
    }`;

    keyFrames += `.alan-btn__image-preview-overlay iframe {
        max-width: calc(100% - 100px);
        max-height: calc(100% - 100px);
        width: calc(100% - 100px);
        height: calc(100% - 100px);
    }`;

    keyFrames += `.alan-btn__image-preview-overlay-close-icon {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        opacity: 0.7;
    }`;

    if (!isMobile()) {
        keyFrames += `.alan-btn__image-preview-overlay-close-icon:hover {
            opacity: 1;
        }`;
    }

    keyFrames += `.alan-btn__image-preview-overlay-left-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 16px;
        cursor: pointer;
        opacity: 0.7;
    }`;

    keyFrames += `.alan-btn__image-preview-overlay-right-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
        cursor: pointer;
        opacity: 0.7;
    }`;

    keyFrames += `.alan-btn__image-preview-overlay-left-icon.invisible {
        opacity:0;
        pointer-events: none;
    }`;

    keyFrames += `.alan-btn__image-preview-overlay-right-icon.invisible {
        opacity:0;
        pointer-events: none;
    }`;

    if (!isMobile()) {
        keyFrames += `.alan-btn__image-preview-overlay-left-icon:hover {
            opacity: 1;
        }`;

        keyFrames += `.alan-btn__image-preview-overlay-right-icon:hover {
            opacity: 1;
        }`;
    }

    keyFrames += getCssForTextChatLinks(getStyleSheetMarker(), uiState.textChat.options);
    keyFrames += getCssForCommandsBlock(getStyleSheetMarker(), uiState.textChat.options);

    keyFrames += getStyleSheetMarker() + `.alan-incoming-msg {
        padding-left: 12px;
        display: flex;
        align-items: center;
        overflow: hidden;
        animation:chat-bubble-appear-w-opacity 300ms ease-in-out forwards 100ms, hide-buble 300ms forwards ease ${uiState.textChat.loaderTimeoutMs}ms !important;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-hide-msg-immidiatelly {
        display: none!important;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-hidden-loader {
        display: none!important;
    }`;

    keyFrames += getStyleSheetMarker() + generateKeyFrame('hide-buble', `
    0% { 
        height: 41px; 
        max-height:41px;    
        min-height: 41px;
    }
      
    100% {
        height: 0px;
        max-height: 0px;
        min-height: 0px;
        padding: 0px;
        margin-bottom:0;
    }`);

    keyFrames += getCssForResponseLoader(getStyleSheetMarker(), uiState.textChat.options);

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-popup {
        width: 100%;
        margin-left: 51px;
        margin-right: 30px;
     }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-buttons {
        width: 100%;
        margin-right: 30px;
     }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-popup {
       position: relative;
       margin-bottom: 16px;
       -webkit-touch-callout: text; /* iOS Safari */
       -webkit-user-select: text; /* Chrome/Safari/Opera */
       -khtml-user-select: text; /* Konqueror */
       -moz-user-select: text; /* Firefox */
       -ms-user-select: text; /* IE/Edge */
       user-select: text;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-popup * {
        -webkit-touch-callout: text; /* iOS Safari */
        -webkit-user-select: text; /* Chrome/Safari/Opera */
        -khtml-user-select: text; /* Konqueror */
        -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* IE/Edge */
        user-select: text;
    }`;

    keyFrames += getStyleSheetMarker(true) + `.hide-alan-btn-when-text-chat-is-opened-immediately .alanBtn {
        transform: scale(0);
        opacity: 0;
        animation: text-chat-disappear-anim 0ms ease-in-out forwards;
    }`;

    keyFrames += getStyleSheetMarker(true) + `.hide-alan-btn-when-text-chat-is-opened .alanBtn {
        transform: scale(0);
        opacity: 0;
        animation: text-chat-disappear-anim ${textChatAppearAnimationMs}ms ease-in-out forwards;
    }`;

    keyFrames += getStyleSheetMarker(true) + `.text-chat-is-closing .alanBtn {
        transform: scale(0);
        opacity: 0;
        animation: text-chat-appear-anim ${textChatAppearAnimationMs}ms ease-in-out forwards;
    }`;

    keyFrames += getStyleSheetMarker(true) + `.hide-alan-btn-when-text-chat-is-opened .alanBtn-recognised-text-holder {
        display: none;
    }`;


    keyFrames += getStyleSheetMarker() + ` mjx-container svg {
        max-width: 100%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar {
        border-radius: 4px;
        margin-right: ${avatarRightMargin}px;
        width: ${avatarSize}px;
        min-width: ${avatarSize}px;
        max-width: ${avatarSize}px;
        min-height: ${avatarSize}px;
        max-height: ${avatarSize}px;
        height: ${avatarSize}px;
        overflow: hidden;
        display: none;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-request-avatar {
        width: ${avatarSize}px;
        min-width: ${avatarSize}px;
        max-width: ${avatarSize}px;
        min-height: ${avatarSize}px;
        max-height: ${avatarSize}px;
        height: ${avatarSize}px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 90% 90%;
        background-image: url(${webOptions?.logoTextChatUserAvatar || btnIcons.alanUserAvatarIconSrc});
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-response-avatar {
        width: ${avatarSize}px;
        min-width: ${avatarSize}px;
        max-width: ${avatarSize}px;
        min-height: ${avatarSize}px;
        max-height: ${avatarSize}px;
        height: ${avatarSize}px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 90% 90%;
        background-image: url(${webOptions?.logoTextChatAvatar || btnIcons.alanLogoIconSrc});
    }`;

    var predefinedBtnColorOptions = mergeOptionsForStyleSheet(webOptions);

    const requestAvatarBg1 = predefinedBtnColorOptions['textChatUserAvatar']?.background?.color[0];
    const requestAvatarBg2 = predefinedBtnColorOptions['textChatUserAvatar']?.background?.color[1];

    const responseAvatarBg1 = predefinedBtnColorOptions['textChatAvatar']?.background?.color[0];
    const responseAvatarBg2 = predefinedBtnColorOptions['textChatAvatar']?.background?.color[1];

    function shouldAvatarHasBorderOrShadow(bg1, bg2, css) {
        if (bg1?.toLowerCase() === 'transparent' || bg2?.toLowerCase() === 'transparent') {
            return '';
        }
        return css;
    }


    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar.request {
        background-image:  linear-gradient(122deg, ${requestAvatarBg1}, ${requestAvatarBg2});
        ${shouldAvatarHasBorderOrShadow(requestAvatarBg1, requestAvatarBg2, `
        
        box-shadow: ${textChatOptions?.bubbles?.request?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
        ${textChatOptions?.bubbles?.request?.borderColor ?
            `border: 1px solid ${textChatOptions?.bubbles?.request?.borderColor};`
            : ''}
            `)}
    }`;

    if (uiState.textChat.available) {
        keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar.response {
            background-image:  linear-gradient(122deg, ${responseAvatarBg1}, ${responseAvatarBg2});
            ${shouldAvatarHasBorderOrShadow(responseAvatarBg1, responseAvatarBg2, `
                
            box-shadow: ${textChatOptions?.bubbles?.response?.hasShadow === false ? 'none' : `0px 1px 3px rgba(16, 39, 126, 0.2)`};
            ${textChatOptions?.bubbles?.response?.borderColor ?
                `border: 1px solid ${textChatOptions?.bubbles?.response?.borderColor};`
                : ''}
                `)}
        }`;
    }


    keyFrames += getStyleSheetMarker() + `.alan-btn_text-chat-full-screen .alan-btn__chat-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar svg {
        width: 90%;
        height: 90%;
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar svg path {
        stroke: ${textChatOptions?.bubbles?.request?.color || `#171717`};
    }`;

    keyFrames += getStyleSheetMarker() + `.alan-btn__chat-avatar svg circle {
        stroke: ${textChatOptions?.bubbles?.request?.color || `#171717`};
    }`;

    return keyFrames;
}

export function getCssForCommandsBlock(styleSheetMarker, textChatOptions) {
    let keyFrames = '';
    const responseBubbleFontColor = textChatOptions?.bubbles?.response?.color || `#171717`;

    const hasLikeBtn = textChatOptions?.bubbles?.response?.likeBtn;
    const hasCopyBtn = textChatOptions?.bubbles?.response?.copyBtn;
    const commandsBlockIsVisible = (hasLikeBtn || hasCopyBtn);

    keyFrames += styleSheetMarker + `.alan-btn__chat-response-commands-wrapper  {
        display: ${commandsBlockIsVisible ? 'block' : 'none'};
        line-height: 0;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response-commands-wrapper-hidden {
        display: none;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response-commands-wrapper-content  {
        ${commandsBlockIsVisible ? `
        position:relative;
        margin-top: 4px;
        display: inline-flex;
        gap: 2px;
        
        ` : ''}
    }`;

    var copyBtnWidth = 20;
    var copyBtnHeight = 24;
    var likeDislikeBtnWidth = 18;
    var likeDislikeBtnHeight = 24;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__like-btn {
        display: ${textChatOptions?.bubbles?.response?.likeBtn ? 'flex' : `none`};
        ${textChatOptions?.bubbles?.response?.likeBtn ? `
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
        width:${likeDislikeBtnWidth}px;
        min-width:${likeDislikeBtnWidth}px;
        height:${likeDislikeBtnHeight}px;
        min-height:${likeDislikeBtnHeight}px;
        ` : ``};
        
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__dislike-btn {
        display: ${textChatOptions?.bubbles?.response?.likeBtn ? 'flex' : `none`};
        ${textChatOptions?.bubbles?.response?.likeBtn ? `
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
        width:${likeDislikeBtnWidth}px;
        min-width:${likeDislikeBtnWidth}px;
        height:${likeDislikeBtnHeight}px;
        min-height:${likeDislikeBtnHeight}px;
        ` : ``};
     }`;


    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn {
        display: ${textChatOptions?.bubbles?.response?.copyBtn ? 'inline-flex' : `none`};
        ${textChatOptions?.bubbles?.response?.copyBtn ? `
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
        width:${copyBtnWidth}px;
        min-width:${copyBtnWidth}px;
        height:${copyBtnHeight}px;
        min-height:${copyBtnHeight}px;
        ` : ``};
     }`;

    const bottomBtnsBgColor = textChatOptions?.bubbles?.response?.bottomBtns?.backgroundColor?.hover || `#dcddde`;
    const bottomBtnsColor = textChatOptions?.bubbles?.response?.bottomBtns?.color || '#17171780';

    if (!isMobile()) {
        keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn:hover  {
            background-color:${bottomBtnsBgColor}!important;
         }`;
        keyFrames += styleSheetMarker + `.alan-btn__chat-response__like-btn:hover  {
            background-color:${bottomBtnsBgColor}!important;
         }`;
        keyFrames += styleSheetMarker + `.alan-btn__chat-response__dislike-btn:hover  {
            background-color:${bottomBtnsBgColor}!important;
         }`;
    }

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn svg {
        width: 20px;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn svg path {
        fill: ${bottomBtnsColor};
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__like-btn svg path  {
        fill: ${bottomBtnsColor};
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__dislike-btn svg path  {
        fill: ${bottomBtnsColor};
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn alan-btn__copy-icon {
        width: 22px;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn .alan-btn__copied-icon {
        display: none;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn.alan-copy-btn-copied .alan-btn__copy-icon {
        display: none;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn.alan-copy-btn-copied .alan-btn__copied-icon {
        display: inline-block;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-btn.alan-copy-btn-copied .alan-btn__copied-icon {
        stroke: ${bottomBtnsColor};
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__code-wrapper {
        position: relative;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__code-wrapper:hover  .alan-btn__chat-response__copy-code-btn {
        display: flex;
        align-items: center;
        justify-content: center;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn {
        position: absolute;
        top: 2px;
        right: 2px;
        width:${copyBtnWidth}px;
        min-width:${copyBtnWidth}px;
        height:${copyBtnHeight}px;
        min-height:${copyBtnHeight}px;
        border-radius: 2px;
        cursor: pointer;
        display: none;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn .alan-btn__copied-icon {
        display: none;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn.alan-copy-btn-copied .alan-btn__copy-icon {
        display: none;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn.alan-copy-btn-copied .alan-btn__copied-icon {
        display: inline-block;
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn svg path {
        fill: ${bottomBtnsColor};
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn.alan-copy-btn-copied .alan-btn__copied-icon {
        stroke: ${bottomBtnsColor};
     }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn svg {
        width:20px;
     }`;


    if (!isMobile()) {
        keyFrames += styleSheetMarker + `.alan-btn__chat-response__copy-code-btn:hover {
             background-color:${bottomBtnsBgColor}!important;
         }`;
    }

    return keyFrames;
}

export function getCssForResponseLoader(styleSheetMarker, textChatOptions) {
    let keyFrames = '';
    const waitingResponseBubbleLayout = textChatOptions?.bubbles?.waitingResponse?.layout || 'default';
    const waitingResponseBubbleLabelIconAlignment = textChatOptions?.bubbles?.waitingResponse?.alignment || 'center';
    const waitingResponseBubbleLoaderIcon = textChatOptions?.bubbles?.waitingResponse?.icon?.svg;
    const waitingResponseBubbleLoaderIconGap = getNumPropVal(textChatOptions?.bubbles?.waitingResponse?.icon?.gap, 8);
    const waitingResponseBubbleLoaderIconDefaultColor = textChatOptions?.bubbles?.waitingResponse?.icon?.default?.fill || `#171717`;
    const waitingResponseBubbleLoaderIconHoverColor = textChatOptions?.bubbles?.waitingResponse?.icon?.hover?.fill || `#0078ff`;

    
    const responseBubbleBg = textChatOptions?.bubbles?.response?.backgroundColor || `#ffffff`;
    const responseBubbleFontColor = textChatOptions?.bubbles?.response?.color || `#171717`;

    const [responseLabelWidth, responseLabelHeight] = parseSvgSize(waitingResponseBubbleLoaderIcon);

    keyFrames += styleSheetMarker + `.alan-text-chat__msg-loader-svg {
        color: ${responseBubbleFontColor};
        min-width: 22px;
        max-width: 22px;
        width: 22px;
        min-height: 22px;
        max-height: 22px;
        height: 22px;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-wrapper {
        display: flex;
        max-width: 100%;
        align-items: ${waitingResponseBubbleLabelIconAlignment};
        gap: ${waitingResponseBubbleLoaderIconGap}px;
        ${waitingResponseBubbleLayout !== 'default' ?
            `
        gap: ${waitingResponseBubbleLoaderIconGap}px;
        `:
            ``
        }
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-icon-holder  {
        display: flex;
        align-items:center;
        justify-content: center;
        cursor: pointer;
        color: ${waitingResponseBubbleLoaderIconDefaultColor};  
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-icon-holder:hover svg  {
        color: ${waitingResponseBubbleLoaderIconHoverColor};    
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-icon {
        display: flex;
        align-items:center;
        justify-content: center;
        width: ${responseLabelWidth}px;
        height: ${responseLabelHeight}px;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-label {
        display: inline-block;
        max-width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-label-default {
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        max-width: calc(100% - 20px);
        display: inline-block;
        display: flex;
        gap: 4px;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-label-default svg path {
        stroke: ${responseBubbleFontColor};
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-label-default svg circle {
        stroke: ${responseBubbleFontColor};
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-loader-label-default.with-text::after {
        position: absolute;
        top: 0;
        right: 0;
        content: '';
        height: 100%;
        width: 20px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${responseBubbleBg} 100%);
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-inner-wrapper {
        display: flex;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg-inner-wrapper.with-text {
        transform: translateY(2px);
        margin-left:2px;
    }`;

    keyFrames += styleSheetMarker + `.alan-btn__chat-incomming-msg {
        border-radius: 50%;
        background-color: ${textChatOptions?.bubbles?.response?.color || `#080808`};
        margin: 2px;
        height: 3px;
        width: 3px;
        animation: alan-dot-bounce 1.5s infinite ease;
    }`;

    keyFrames += styleSheetMarker + `.msg-2 {
        animation-delay: .2s;
    }`;

    keyFrames += styleSheetMarker + `.msg-3 {
        animation-delay: .3s;
    }`;

    keyFrames += styleSheetMarker + generateKeyFrame('alan-dot-bounce', `
    0%, 100% { opacity:1;}
      
    60% {
        transform: translateY(3px);
        opacity:.0;
    }`);

    return keyFrames;
}

export function getCssForTextChatLinks(styleSheetMarker, textChatOptions) {
    let result = '';
    const responseBubbleFontSize = +(textChatOptions?.bubbles?.response?.fontSize || 15);

    const learnMoreLinkBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.borderColor || `#EAF2FC`;
    const learnMoreLinkHoverBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.borderColor || `#EAF2FC`;
    const learnMoreLinkActiveBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.borderColor || `#EAF2FC`;


    const learnMoreLinkBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.backgroundColor || `transparent`;
    const learnMoreLinkHoverBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.backgroundColor || `#EAF2FC`;
    const learnMoreLinkActiveBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.backgroundColor || `#EAF2FC`;


    const learnMoreLinkNumberBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.linkNumberBackgroundColor || `#EAF2FC`;
    const learnMoreLinkNumberHoverBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.linkNumberBackgroundColor || `#EAF2FC`;
    const learnMoreLinkNumberActiveBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.linkNumberBackgroundColor || `#EAF2FC`;

    const learnMoreTopLeftBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.topLeft, 4);
    const learnMoreTopRightBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.topRight, 4);
    const learnMoreBottomRightBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.bottomRight, 4);
    const learnMoreBottomLeftBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.bottomLeft, 4);


    result += styleSheetMarker + `.alan-btn__chat-response-links-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }`;

    result += styleSheetMarker + `.alan-btn__chat-response-links-wrapper.with-content-on-top {
        padding: 10px 0 0 0;
        margin-top: 10px;
    }`;

    result += styleSheetMarker + `.alan-btn__chat-response-link {
        border: 1px solid ${learnMoreLinkBorderColor};
        border-radius: ${learnMoreTopLeftBorderRadius}px ${learnMoreTopRightBorderRadius}px ${learnMoreBottomRightBorderRadius}px ${learnMoreBottomLeftBorderRadius}px;
        background-color: ${learnMoreLinkBackgroundColor};
        margin-right: 10px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        max-width: 100%;
    }`;

    if (!isMobile()) {
        result += styleSheetMarker + `.alan-btn__chat-response-links-wrapper a.alan-btn__chat-response-link:hover  {
            text-decoration: none !important;
            background-color: ${learnMoreLinkHoverBackgroundColor};
            border-color: ${learnMoreLinkHoverBorderColor};
        }`;

        result += styleSheetMarker + `.alan-btn__chat-response-links-wrapper a.alan-btn__chat-response-link:active  {
            text-decoration: none !important;
            background-color: ${learnMoreLinkActiveBackgroundColor};
            border-color: ${learnMoreLinkActiveBorderColor};
        }`;
    }

    result += styleSheetMarker + `.alan-btn__chat-response-link-icon-wrapper {
        padding: 9px 4px;
        background-color: ${learnMoreLinkNumberBackgroundColor};
        border-radius: ${getInnerBorderRadiusProp(learnMoreTopLeftBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreTopRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomLeftBorderRadius)}px;
        display: inline-block;
        min-width: 28px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }`;

    if (!isMobile()) {
        result += styleSheetMarker + `.alan-btn__chat-response-link:hover .alan-btn__chat-response-link-icon-wrapper  {
            background-color: ${learnMoreLinkNumberHoverBackgroundColor};
        }`;

        result += styleSheetMarker + `.alan-btn__chat-response-link:active .alan-btn__chat-response-link-icon-wrapper  {
            background-color: ${learnMoreLinkNumberActiveBackgroundColor};
        }`;
    }

    const linkColor = uiState.textChat.options?.bubbles?.response?.links?.color?.default || `#4183c4`;
    const linkHoverColor = uiState.textChat.options?.bubbles?.response?.links?.color?.hover || `#4183c4`;

    result += styleSheetMarker + `.alan-btn__chat-response-link svg path {
        fill: ${linkColor};
    }`;
    if (!isMobile()) {
        result += styleSheetMarker + `.alan-btn__chat-response-link:hover svg path {
        fill: ${linkHoverColor};
    }`;
    }

    result += styleSheetMarker + `.alan-btn__chat-response-link-title {
        overflow: hidden;
        max-width: calc(100% - 15px);
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        padding: 4px 4px;
    }`;

    result += styleSheetMarker + `.alan-btn__chat-response-link svg {
        flex-shrink: 0;
    }`;
    return result;
}